import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CollapsibleBlock from "src/components/CollapsibleBlock/CollapsibleBlock";
import AttachmentsSelector from "src/components/AttachmentsSelector/AttachmentsSelector";
import useCollapsibles from "src/hooks/useCollapsibles";
import { MdOutlineAttachment } from "react-icons/md";
import { ICON_SIZES } from "src/constants/icons";

export enum EAttachmentsTableViewStyle {
  TABLE = "table",
  GRID = "grid",
}

interface IRecurringTransactionAttachments {
  attachments: Array<any>;
  onChange: (data: any) => void;
  onClick: (data: any) => void;
}

const RecurringTransactionAttachments: React.FC<
  IRecurringTransactionAttachments
> = ({ attachments, onChange, onClick }) => {
  const { t } = useTranslation(["modals"]);
  const [totalFiles, setTotalFiles] = useState<number>(0);
  const [unsavedAttachments, setUnsavedAttachments] = useState<any[]>([]);

  useEffect(() => {
    setTotalFiles(unsavedAttachments?.length + attachments?.length);
  }, [unsavedAttachments, attachments]);

  const { collapsiblePreferences, updateCollapsible } = useCollapsibles();

  return (
    <CollapsibleBlock
      keepAlive
      title={t("modals:register_payment.collapsibles.files.title")}
      badge={
        totalFiles
          ? t("modals:register_payment.collapsibles.files.count", {
              count: totalFiles,
            })
          : t("modals:register_payment.collapsibles.files.no_attachments")
      }
      // open={collapsiblePreferences.recurringTransactionAttachmentsOpen}
      blocked
      open
      onChange={(isOpen: boolean) => {
        updateCollapsible({ recurringTransactionAttachmentsOpen: isOpen });
      }}
      uppercase
      icon={<MdOutlineAttachment size={ICON_SIZES.SM} />}
    >
      <>
        <AttachmentsSelector
          savedAttachments={attachments}
          onChange={(data: any) => {
            setUnsavedAttachments(data?.unsaved);
            onChange(data);
          }}
          onClick={(data: any) => onClick(data)}
        />
      </>
    </CollapsibleBlock>
  );
};

export default RecurringTransactionAttachments;
